import { cn } from "../util.cn/cn";

interface DangerouslyHtmlContentProps {
  className?: string;
  dangerouslyHtmlContent: string;
}

const DangerouslyHtmlContent = (props: DangerouslyHtmlContentProps) => {
  const { dangerouslyHtmlContent, className, ...divProps } = props;

  return (
    <div
      {...divProps}
      className={cn("prose text-gray-12", className)}
      style={{
        maxWidth: "unset",
      }}
      dangerouslySetInnerHTML={{
        __html: dangerouslyHtmlContent,
      }}
    />
  );
};

export { DangerouslyHtmlContent };
